import * as React from 'react';
import { IncentivesCollectionCarousel } from '@shared-ui/retail-incentives-collection-carousel';
import { adaptSearchCriteria } from 'stores/adapters/bex-api/common/search-criteria-adapter';
import { SimpleLazyLoadWrapper } from 'components/common/lazy/simple-lazy-load-wrapper';
const defaultItemsVisibleForTracking = {
  small: 3,
  medium: 4,
  large: 4,
  extraLarge: 4,
  defaultInViewport: 4
};
export const IncentivesCollectionCarouselWrapper = props => {
  const {
    inputs,
    pageContext,
    itemsVisibleForTracking = defaultItemsVisibleForTracking,
    skipSsr = false
  } = props;
  const collectionId = inputs === null || inputs === void 0 ? void 0 : inputs.collectionId;
  const {
    context,
    propertySearch
  } = pageContext || {};
  if (!context || !(propertySearch === null || propertySearch === void 0 ? void 0 : propertySearch.regionId) || !collectionId) {
    return null;
  }
  const searchCriteria = adaptSearchCriteria(context, propertySearch);
  return React.createElement(SimpleLazyLoadWrapper, {
    placeholder: React.createElement(React.Fragment, null)
  }, React.createElement(IncentivesCollectionCarousel, {
    inputs: {
      collectionId: collectionId,
      pageContext: {
        propertySearch: searchCriteria
      }
    },
    showPlaceholder: false,
    itemsVisibleForTracking: itemsVisibleForTracking,
    skipSsr: skipSsr
  }));
};
IncentivesCollectionCarouselWrapper.displayName = 'IncentivesCollectionCarouselWrapper';